import ProcessingLoader from './ProcessingLoader'

export default ProcessingLoader
